import { cache } from 'react';
import type { Locale } from '@tuic/i18n';
import { createCssClient } from '../utils';
import { tryRequest } from '../utils/try-request';
import { baseDataResponse } from '../generated';

// TODO update with spec when possible again
export type BaseDataResponse = Omit<baseDataResponse, 'cruise'> & {
  cruise: baseDataResponse['cruise'] & {
    cabinTypeInfos: { code: string; name: string }[];
  };
  geoLocations: baseDataResponse['geoLocations'] & {
    regionInfos: { code: string; name: string }[];
  };
};

export const getBaseData = cache(async (locale: Locale) => {
  // TODO currencly the api is extremly slow to enhance development
  // TODO i cache this data for now
  // return import('./base-data-fallback.json') as Promise<BaseDataResponse>;

  const css = createCssClient();

  return (await tryRequest(() => {
    // TODO locale param noch nicht spezifiziert
    return css.baseData.getBaseData();
  }, `Could not fetch cruise list. Locale: ${locale}`)) as BaseDataResponse;
});

export const memoizeBaseData = cache(getBaseData);
